export const environment = {
  production: true,
  url: 'chatbar-v2/smarthelp',
  urlback: '',
  appkeyValida: '2f6d8a36-7316-4741-9fe2-e6c45b1305d4',
  token: '6e053747-1005-4ba0-aea3-backoffice',
  apigee: '@client-secret-apigee',
  controlVariable: false
};
